export function convertName (name: string): string {
  return name.charAt(0).toUpperCase() + name.slice(1);
}

export function convertNameInitial (user) {
  return (
    user.userFirstName.charAt(0).toUpperCase() +
    user.userLastName.charAt(0).toUpperCase()
  );
}

export function DisplayUserName (user) {
  const lastName =
    user.userLastName.charAt(0).toUpperCase() + user.userLastName.slice(1);
  const firstName =
    user.userFirstName.charAt(0).toUpperCase() + user.userFirstName.slice(1);
  return `${lastName}, ${firstName}`;
}
